var player = (function (my) {
  // 当前待播放音频地址
  var curUrl
  // 上一个待播放音频地址
  var lastUrl
  var $jplayer
  // var Bubble
  // 回调函数
  var callback

  var stopEvent = null
  var playEvent = null
  var playingEvent = null
  var playErrorEvent = null
  // 记录player监测flash未安装时是否发起请求swf文件
  var isReqSwf = false
  // stoped后禁止调用canplay
  var canplayStatus = false

  my.getStatus = function () {
    return $jplayer.attr('status')
  }

  my.buttonClick = function (url, cb, cbPlaying, cbStop, cbError, cbPlay) {
    // 保存回调
    callback = cb
    // 重置回调
    stopEvent = cbStop
    playEvent = cbPlay
    playingEvent = cbPlaying
    playErrorEvent = cbError
    var urlParam = {}
    if (typeof url === 'string') {
      urlParam = {
        mp3: url
      }
    } else {
      urlParam = url
    }

    // 保存上个元素的信息
    lastUrl = curUrl
    curUrl = JSON.stringify(urlParam)

    if (lastUrl === curUrl) {
      my.play(false)
      return
    }
    my.play(true)
  }
  // 播放：isNew==true，代表重新加载音频
  my.play = function (isNew) {
    if (isNew) {
      $jplayer.jPlayer('setMedia', JSON.parse(curUrl || '{}')).jPlayer('play')
    } else {
      $jplayer.jPlayer('play')
    }
  }
  my.playUrl = function (url) {
    curUrl = ''
    stopEvent = null
    playEvent = null
    playingEvent = null
    playErrorEvent = null
    var urlParam = {}
    if (typeof url === 'string') {
      urlParam = {
        mp3: url
      }
    } else {
      urlParam = url
    }

    $jplayer.jPlayer('setMedia', urlParam).jPlayer('play')
  }
  // 暂停
  my.pause = function (t) {
    if (curUrl) {
      if (t === 0) {
        stopEvent = null
        playEvent = null
        playingEvent = null
        playErrorEvent = null
      }
      $jplayer.jPlayer('pause')
      if (stopEvent) {
        stopEvent()
      }
      if (callback) {
        callback()
      }
    }
  }
  // 停止
  my.stop = function () {
    if (this.getStatus() === '1' && curUrl) {
      $jplayer.jPlayer('stop')
    }
  }
  // 初始化
  my.init = function (baseUrl) {
    $jplayer = $('#jplayer')
    $jplayer.jPlayer(
      {
        ready: function () {
          $jplayer.attr('status', '1')
        },
        // 监听播放事件 不是监听canplay事件
        play: function (event) {
          if (!event.jPlayer.status.paused) {
            canplayStatus = true
            if(event.jPlayer.status.duration === 0) {
              if (playEvent) {
                playEvent()
              }
            }else {
              if (playingEvent) {
                playingEvent()
              }
            }
          }
        },
        canplay: function (event) {
          if (playingEvent && canplayStatus) {
            playingEvent()
          }
        },
        // 当播放结束时调用
        ended: function () {
          if (stopEvent) {
            canplayStatus = false
            stopEvent()
          }
          if (callback) {
            curUrl = ''
            callback()
            callback = undefined
          }
        },
        // 播放异常时调用
        error: function (event) {
          // 如果浏览器选择使用flash播放，首次初始化播放器时监测flash是否满足使用
          // 如果不满足，百度统计一次，并请求一个空的swf文件触发浏览器下载flash插件
          if (!isReqSwf && event.jPlayer.version.flash === 'unknown') {
            $('#flashZone').html(genPlayerHtml('/flash/Jplayer.swf'))
            isReqSwf = true
          }
          if (playErrorEvent) {
            playErrorEvent(event)
          }
        },
        // 播放器地址
        swfPath: '/hera/swf/Jplayer.swf',
        solution: 'html,flash',
        supplied: 'wav, mp3'
      })
  }
  function genPlayerHtml (flashUrl) {
    var htmlStr = ''
    htmlStr += '<object id="AudioFlashPlayer" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=8,0,0,0" width="0" height="0">'
    htmlStr += '<param name="movie" value="' + flashUrl + '" /> <param name="quality" value="high" /><param name="wmode" value="transparent" /> <param name="FlashVars" value="Caller= " /><param name="allowscriptaccess" value="sameDomain" /><param name="swfversion" value="10.0.22.0" />'
    htmlStr += '<embed src="' + flashUrl + '" id="AudioFlashPlayerFF"  width="0" height="0" quality="high"  pluginspage="http://www.adobe.com/shockwave/download/download.cgi?P1_Prod_Version=ShockwaveFlash" wmode="transparent" swfversion="10.0.22.0"  flashvars=""  type="application/x-shockwave-flash" allowscriptaccess="sameDomain" > '
    htmlStr += '</embed></object>'
    return htmlStr
  }

  return my
}({}))
player.init()
export {
  player
}



// WEBPACK FOOTER //
// ./src/js/libs/jplayer/init-audio.js